import { api } from './api'
import { toUserFacingApiError } from '../utils/userFacingError'

function assertSuccess(body: unknown) {
  const b = body as { success?: boolean; message?: string; error?: { code?: string }; data?: unknown }
  if (!b?.success) {
    const err = new Error(b?.message || 'Request failed') as Error & { code?: string }
    err.code = b.error?.code
    throw err
  }
  return b.data
}

export type GoLiveBlocker = {
  code: string
  message: string
  overridable: boolean
}

export type GoLiveReadiness = {
  storeId: number
  organisationId: number
  organisationStatus: string
  storePlatform: string
  alreadyLive: boolean
  ready: boolean
  blockers: GoLiveBlocker[]
  steps: Array<{ id: string; title: string; complete: boolean; optional?: boolean }>
  completedRequiredCount: number
  requiredTotalCount: number
  billing: {
    required: boolean
    status: string | null
    ok: boolean
  }
  activated?: boolean
  message?: string
  forced?: boolean
}

function apiError(err: unknown, fallback: string) {
  return toUserFacingApiError(err, fallback)
}

export async function fetchGoLiveReadiness(storeId: number): Promise<GoLiveReadiness> {
  try {
    const { data } = await api.get(`/stores/${storeId}/go-live-readiness`)
    return assertSuccess(data) as GoLiveReadiness
  } catch (e) {
    throw apiError(e, 'Could not load go-live readiness')
  }
}

export async function postGoLive(storeId: number): Promise<GoLiveReadiness> {
  try {
    const { data } = await api.post(`/stores/${storeId}/go-live`, {})
    return assertSuccess(data) as GoLiveReadiness
  } catch (e) {
    throw apiError(e, 'Could not go live')
  }
}
